import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './users/login-page.container';
import { WeclomeComponent } from './welcome-page/welcome-page';
import { AuthGuard } from './users/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/products/suppliers', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'config', loadChildren: './config/config.module#ConfigModule' },
  { path: 'welcome', component: WeclomeComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts